import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_MY_STUDENT_DATA_REQUESTS } from '@/graphql/studentDataRequests';
import type { MyStudentDataRequestsQuery, MyStudentDataRequestsQueryVariables } from '@/types/operations';

/** The signed-in student's open data requests, unanswered first. */
export function useMyStudentDataRequests(options: { enabled?: Ref<boolean> } = {}) {
  const { result, loading, error, refetch } = useQuery<MyStudentDataRequestsQuery, MyStudentDataRequestsQueryVariables>(
    GET_MY_STUDENT_DATA_REQUESTS,
    {},
    () => ({ fetchPolicy: 'cache-and-network', enabled: options.enabled?.value ?? true }),
  );

  return {
    requests: computed(() => result.value?.myStudentDataRequests ?? []),
    loading,
    error,
    refetch,
  };
}
